import { registerIcons } from 'mussel'

import user from '@icons/user.svg'
import home from '@icons/home.svg'
import password from '@icons/key.svg'
import logout from '@icons/logout.svg'
import message from '@icons/message.svg'
import applications from '@icons/apps.svg'
import module from '@icons/box.svg'
import command from '@icons/command.svg'
import childMenu from '@icons/menu.svg'
import file from '@icons/file.svg'
import download from '@icons/download.svg'
import bell from '@icons/bell.svg'
import cloudDownload from '@icons/cloud-download.svg'
import minusVertical from '@icons/minus-vertical.svg'

import apps from './application'
import orgs from './org-type'
import menus from './menu'

import bookmark from '@icons/bookmark.svg'
import run from '@icons/run.svg'

import send from '@icons/send.svg'
import mailBox from '@icons/mailbox.svg'

registerIcons({
  ...apps,
  ...orgs,
  ...menus,
  home,
  user,
  logout,
  message,
  password,
  applications,
  module,
  command,
  childMenu,
  file,
  download,
  bell,
  cloudDownload,
  minusVertical,
  bookmark,
  run,
  send,
  mailBox
})
